import { Entity } from '@/engine/core/entity';
import { action, computed } from 'mobx';

export interface IViewPortTooltipProps {
  descriptor: string;
  text: string | Array<string>;
  viewPort: string;
  isShown: boolean;
  placement: 'top' | 'bottom' | 'left' | 'right';
}

export class ViewPortTooltipViewModel extends Entity<IViewPortTooltipProps> {
  @computed
  public get viewPort(): string {
    return this.props.viewPort;
  }

  @computed
  public get text(): string | Array<string> {
    return this.props.text;
  }

  @computed
  public get descriptor(): string {
    return this.props.descriptor;
  }

  @computed
  public get placement(): 'top' | 'bottom' | 'left' | 'right' {
    return this.props.placement;
  }

  @computed
  public get isShown(): boolean {
    return this.props.isShown;
  }

  @action
  public hide(): void {
    this.props.isShown = false;
  }
}
